import maskFieldValue from './maskFieldValue'

function maskFormValues(data, fields) {
  let maskedData = {}

  for (let field of fields) {
    maskedData[field.name] = maskFieldValue(data[field.name], field.mask)
  }

  return maskedData
}

export default maskFormValues
